module.exports = __webpack_public_path__ + "media/country_flags/mu-b9520906.png";